import { Cookies } from 'react-cookie';
import {
  DAPI_CLIENT_ID,
  DAPI_CLIENT_SECRET,
  DAPI_HOST,
  LONG_TERM_SESSION_ID_COOKIE_NAME,
} from '../../config/index';
import { apiPostDispatchable } from '../../core/dapi';
import logger from '../logger/index';
import { PERSISTED_LOGIN_ID } from '../../components/SignUpForm/Fields/ids';

const getLoginUrl = () => `${DAPI_HOST}/v1/auth/token`;
const getRemoteValidatePhoneUrl = (phone: any) => `${DAPI_HOST}/v1/validate/phone/${phone}`;
const getGenerateOneTimePasswordUrl = () => `${DAPI_HOST}/v1/otp/generate`;

const buildLoginByOtpPostData = (props: any) => {
  const device_id = new Cookies().get(LONG_TERM_SESSION_ID_COOKIE_NAME);

  return {
    client_id: DAPI_CLIENT_ID,
    client_secret: DAPI_CLIENT_SECRET,
    phone: props.phone,
    code: props.code,
    persist: props[PERSISTED_LOGIN_ID],
    grant_type: 'otp_credentials',
    device_id,
    last_name: props.last_name,
    date_of_birth: props.date_of_birth,
    enable_account_verification: true,
    accepted_tos: true,
  };
};

const buildLoginRefresh = (refreshToken: any) => ({
  client_id: DAPI_CLIENT_ID,
  client_secret: DAPI_CLIENT_SECRET,
  grant_type: 'refresh_token',
  refresh_token: refreshToken,
});

const postLoginDispatchable = (props: any, onSuccess: any, onFailure: any) => {
  const postData = buildLoginByOtpPostData(props);

  return (dispatch: any) => {
    dispatch(apiPostDispatchable(getLoginUrl(), postData, onSuccess, onFailure));
  };
};

const postLoginRefresh = (session: any, onSuccess: any, onFailure: any) => {
  const postData = buildLoginRefresh(session.refresh_token);

  return (dispatch: any) => {
    logger.debug('Submitting Refresh');
    logger.debug(postData);
    dispatch(apiPostDispatchable(getLoginUrl(), postData, onSuccess, onFailure));
  };
};

export {
  postLoginRefresh,
  postLoginDispatchable,
  buildLoginByOtpPostData,
  getRemoteValidatePhoneUrl,
  getGenerateOneTimePasswordUrl,
};
